import { RouteItem } from '@eastcoal/router/types/route'

import { ALL_MEMBER_LIST_PAGE_UUID } from './uuid'

export const allMemberRoute: RouteItem = {
  title: '全部会员',
  path: '/member/list/all',
  uuid: ALL_MEMBER_LIST_PAGE_UUID,
  Component: () => import('./index')
}
